import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

function PhysicalProducts() {
  const [products, setProducts] = useState([
    {
      id: 1,
      name: "Clay cutter set",
      price: "£12.00",
      desc: "A collection of 3d printable Clay cutters in an STL format..",
      image: null,
    },
    {
      id: 2,
      name: "3D printables",
      price: "£8.50",
      desc: "Check out our 3D print files",
      image: null,
    },
    {
      id: 3,
      name: "Cricut projects",
      price: "£5.00",
      desc: "Projects to use with Cricut.",
      image: null,
    },
  ]);

  // Track button hover states
  const [hoveredButtonId, setHoveredButtonId] = useState(null);

  // Handle local image upload preview
  const handleImageUpload = (productId, event) => {
    const file = event.target.files[0];
    if (file) {
      const localImageUrl = URL.createObjectURL(file);
      setProducts((prevProducts) =>
        prevProducts.map((p) =>
          p.id === productId ? { ...p, image: localImageUrl } : p
        )
      );
    }
  };

  return (
    <div className="container">
      {/* Page Header */}
      <div className="logo-area">
        <h1 className="main-title">Physical Products</h1>
      </div>

      <div
        className="welcome-badge"
        style={{
          display: "inline-block",
          fontSize: "1.2rem",
          padding: "6px 16px",
          borderRadius: "20px",
          marginBottom: "20px",
          fontWeight: "700",
        }}
      >
        UK Shipping Only
      </div>

      <p className="prompt-text">
        Beautiful, hand-crafted goods delivered straight to your door.
      </p>

      {/* Product Grid */}
      <div
        className="product-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "25px",
          margin: "40px 0",
          textAlign: "left",
        }}
      >
        {products.map((product) => {
          const isHovered = hoveredButtonId === product.id;

          return (
            <div
              key={product.id}
              className="product-card"
              style={{
                backgroundColor: "#fffbf5",
                border: "3px solid #2b2621",
                borderRadius: "20px",
                padding: "25px",
                boxShadow: "0 4px 0 #2b2621",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                {/* 📸 Dynamic Image Box */}
                <div
                  style={{
                    width: "100%",
                    height: "180px",
                    backgroundColor: "#eae3d2",
                    border: "2px dashed #2b2621",
                    borderRadius: "12px",
                    marginBottom: "15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  {product.image ? (
                    <img
                      src={product.image}
                      alt={product.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div style={{ textAlign: "center", padding: "10px" }}>
                      <span style={{ fontSize: "2rem", display: "block" }}>
                        📷
                      </span>
                      <label
                        style={{
                          fontSize: "0.85rem",
                          fontWeight: "bold",
                          textDecoration: "underline",
                          cursor: "pointer",
                          color: "#2b2621",
                        }}
                      >
                        Upload Photo
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleImageUpload(product.id, e)}
                          style={{ display: "none" }}
                        />
                      </label>
                    </div>
                  )}

                  {/* Small change button if image already exists */}
                  {product.image && (
                    <label
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "8px",
                        backgroundColor: "rgba(43,38,33,0.8)",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        fontSize: "0.75rem",
                        cursor: "pointer",
                      }}
                    >
                      Change
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageUpload(product.id, e)}
                        style={{ display: "none" }}
                      />
                    </label>
                  )}
                </div>

                <h3
                  style={{
                    fontSize: "1.5rem",
                    margin: "0 0 10px 0",
                    color: "#2b2621",
                  }}
                >
                  {product.name}
                </h3>
                <p
                  style={{
                    fontSize: "1rem",
                    color: "#666",
                    margin: "0 0 15px 0",
                    minHeight: "40px",
                  }}
                >
                  {product.desc}
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "15px",
                }}
              >
                <span style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
                  {product.price}
                </span>

                <button
                  className="btn"
                  onMouseEnter={() => setHoveredButtonId(product.id)}
                  onMouseLeave={() => setHoveredButtonId(null)}
                  style={{
                    minWidth: "auto",
                    padding: "8px 16px",
                    fontSize: "1rem",
                    borderRadius: "12px",
                    transition: "all 0.2s ease",
                    backgroundColor: isHovered ? "#cb7a61" : "#c6a47e",
                    transform: isHovered ? "translateY(-2px)" : "none",
                    boxShadow: isHovered
                      ? "0 4px 0 #2b2621"
                      : "0 2px 0 #2b2621",
                  }}
                >
                  View Item
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Navigation Footer */}
      <div style={{ marginTop: "50px" }}>
        <Link to="/" className="btn btn-wide">
          ← Back to Homepage
        </Link>
      </div>
    </div>
  );
}

export default PhysicalProducts;
